import LayoutComponent from "../components/LayoutComponent";
import {Form, Input, Button, DatePicker, Select, Table, Tag} from 'antd';
import {useEffect, useState} from "react";
import {useApi} from "../provider/ApiProvider";
import moment from "moment";
import {FileExcelOutlined, PlusOutlined} from "@ant-design/icons";
import {Excel} from "antd-table-saveas-excel";
import TableComponent from "../components/TableComponent";
import UserDialog from "../dialogs/UserDialog";
const { RangePicker } = DatePicker;
const rangeConfig = {
    rules: [{ type: 'array', required: true, message: 'Please select time!' }],
};
const { Option } = Select;

const columns = [
    {
        title: 'Firma Adı',
        dataIndex: 'Firma',
        key: 'Firma',
    },
    {
        title: 'Tc Kimlik No',
        dataIndex: 'TCKimlikNo',
        key: 'TCKimlikNo',
    },
    {
        title: 'Adı Soyadı',
        render:(record) => (
            <span>{`${record.Adi} ${record.Soyadi}`}</span>
        )
    },
    {
        title: 'Giriş Çıkış',
        key: 'GirisCikis',
        render:(record) => (
            <Tag color={record.GirisCikis === 'Giriş' ? 'green' : 'red'} >{record.GirisCikis}</Tag>
        )
    },
    {
        title: 'İşlem Tarihi',
        key: 'IslemTrh',
        render:(record) => (
            <strong> {record.IslemTrh}</strong>
        )
    },

];


export default function LoginInformations(){
    const [isCompanyIdRequired, setIsCompanyIdRequired] = useState(false);
    const [isIdentityNumberRequired, setIsIdentityNumberRequired] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [dataSource, setDataSource] = useState({totalCount: 0, items: []})
    const [loading, setLoading] = useState(false);
    const {api} = useApi();

    useEffect(() => {
        getCompanies()
    },[]);

    const getCompanies = async () => {
        setLoading(true);
        await api.get('/companyRouter/company/all?skip=0&max=10000').then(resp => {
            setCompanies(resp.data);
        }).finally(() => {
            setLoading(false);
        })
    }

    const onFinish = async (values) => {
        const startDate = moment(values.dateArray[0]).set({hour:0,minute:0,second:0,millisecond:0}).format('YYYY-MM-DD HH:mm:ss');
        const endDate = moment(values.dateArray[1]).set({hour:0,minute:0,second:0,millisecond:0}).format('YYYY-MM-DD HH:mm:ss');
        setLoading(true);
        await api.post('/userRouter/user/getLogs',{
            identityNumber: values.identityNumber,
            companyId: values.companyId,
            startDate,
            endDate
        }).then(resp => {
            var data = resp.data.map(item => {
                return {
                    ...item,
                    ...{IslemTrh: moment(item.IslemTrh).format('DD.MM.YYYY HH:mm')}
                };
            })
            setDataSource({totalCount: resp.totalCount, items:data} )

        }).finally(() => {
            setLoading(false);
        })
    };
    const columnsexcel = [

        {
            title: 'Firma Adı',
            dataIndex: 'Firma',
            key: 'Firma',
        },
        {
            title: 'Tc Kimlik No',
            dataIndex: 'TCKimlikNo',
            key: 'TCKimlikNo',
        },
        {
            title: 'Adı',
            dataIndex: 'Adi',

        },
        {
            title: 'Soyadı',
            dataIndex: 'Soyadi',

        },
        {
            title: 'Giriş Çıkış',
            key: 'GirisCikis',
            dataIndex : 'GirisCikis'

        },
        {
            title: 'İşlem Tarihi',
            key: 'IslemTrh',
            dataIndex : 'IslemTrh'

        },
    ];


    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    return (
        <LayoutComponent
            title={"Giriş-Çıkış Bilgileri"}
            subTitle='* Başlangıç ve bitiş tarihi seçmek zorunlu, Tc Kimlik No veya Firmadan sadece birini seçmelisiniz.'
            links={
            [
                {
                    title: 'Giriş Çıkış Bilgileri',
                    url: '/login-informations',
                },

            ]}newButton={<>
        <div>



            <Button
                type="primary"
                icon={<FileExcelOutlined />}
                onClick={() => {
                    const excel = new Excel();
                    excel
                        .addSheet('Kullanıcılar')
                        .addColumns(columnsexcel)
                        .addDataSource(dataSource.items)
                        .saveAs('Kullanıcılar.xlsx');
                }}
            >
                Excel
            </Button>
        </div>

    </>}>
        <div>
            <Form
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <div className="login-informations">
                    <div className="filter-box">
                        <Form.Item label="Başlangıç-Bitiş Tarihi" name="dateArray" {...rangeConfig}>
                            <RangePicker />
                        </Form.Item>
                        <Form.Item
                            style={{marginLeft: '1.5em'}}
                            name="identityNumber"
                            rules={[{ required: isIdentityNumberRequired, message: 'Tc Giriniz' }]}
                            label="Tc Kimlik No"
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            style={{marginLeft: '1.5em'}}
                            name="companyId"
                            rules={[{ required: isCompanyIdRequired, message: 'Firma Seçiniz' }]}
                            label="Firma"
                        >
                            <Select
                                showSearch
                                placeholder="Firma"
                                optionFilterProp="children"
                                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                style={{width: '15vw'}}
                                allowClear={true}
                            >
                                {companies.length > 0 && companies.map((item, idx) => (
                                    <Option key={"company-" + idx} value={item.id}>{item.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                            <Button type="primary" htmlType="submit">
                                Filtrele
                            </Button>
                        </Form.Item>
                    </div>



                </div>
            </Form>
        </div>
            <TableComponent
                columns={columns}
                data={dataSource}
                loading={loading}
            />
        </LayoutComponent>
    )
}

